import React, { useContext, useState } from 'react';
import PanelElement from './PanelElement';
import { Context } from '../../Context/Context';

function LeftPanel({panelItems, activeTab, activePanel, setActivePanel}) {
  const {userDetails} = useContext(Context);
  return (
    <>
       <div className='bg-ivory flex flex-col font-normal w-full pt-6 h-full items-start   '>
         {
          panelItems.map ((item, key) => (
            <>
            <PanelElement 
              id={item?.key ? parseInt(item.key) : key}
              name={item.menu}
              activePanel={activePanel}
              setActivePanel={setActivePanel}
              activeTab={activeTab}
              count = {item.count}
              />
            </>
            
          ))
         }  
        </div>
    </>
    
  )
}

export default LeftPanel